import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './DrMaxWrapper.module.scss';
import ContentCard from '../../../BaseModule/Components/Layout/ContentCard/ContentCard';
import TextInput from '../../../BaseModule/Components/Input/TextInput';
import FormControl from '../../../BaseModule/Components/Form/FormControl';
import {
	DrMaxOpeningHour,
	DrMaxOpeningHourItem,
	DrMaxProductsInStock,
	useLazyGetDrMaxPickupPlacesQuery,
} from '../../../../graphql/graphql';
import { debounce } from 'lodash';
import DrMaxPharmacyList from '../DrMaxPharmacyList/DrMaxPharmacyList';
import { Pharmacy } from '../DrMaxPharmacyList/DrMaxPharmacyListItem';
import DrMaxReserveMedicamentsModal from '../DrMaxReserveMedicaments/DrMaxReserveMedicamentsModal';
import Loading from '../../../BaseModule/Components/Loading';
import { isAllInStock } from '../../Utils/isAllInStock';

interface Props {
	prescriptionId: string;
}
const DrMaxWrapper: React.FC<Props> = ({ prescriptionId }) => {
	const [getDrMaxPickupPlaces] = useLazyGetDrMaxPickupPlacesQuery();
	const [pharmacies, setPharmacies] = useState<Pharmacy[]>([]);
	const [selectedPharmacy, setSelectedPharmacy] = useState<Pharmacy>();
	const [isLoading, setIsLoading] = useState(false);

	const searchPharmacies = async (e: any) => {
		if (e.target.value.length > 3) {
			setIsLoading(true);
			const { drmaxPickupPlaces } = await getDrMaxPickupPlaces({
				search: e.target.value,
				prescriptionId,
			}).unwrap();

			const items: Pharmacy[] = [];

			for (const pharmacy of drmaxPickupPlaces?.data || []) {
				items.push({
					id: pharmacy?.id,
					name: pharmacy?.name ?? '',
					isOpen: pharmacy?.isOpen ?? false,
					openingHours: pharmacy?.openingHours as DrMaxOpeningHourItem[],
					distanceFormatted: pharmacy?.distanceFormatted ?? undefined,
					inStock: pharmacy?.productsInStock
						? isAllInStock(pharmacy?.productsInStock as DrMaxProductsInStock[])
						: false,
				});
			}
			setPharmacies(items);
			setIsLoading(false);
		}
	};

	const debounced = useMemo(() => debounce(searchPharmacies, 1000), []);

	const handlePickPharmacy = (pharmacy: Pharmacy) => {
		setSelectedPharmacy(pharmacy);
	};

	return (
		<>
			<ContentCard>
				<FormControl marginBottom='0'>
					<TextInput
						placeholder={'component.drmax.enterCityOrPostCode'}
						onChange={debounced}
					/>
				</FormControl>
			</ContentCard>
			<div className={'mt-3'}>
				<DrMaxPharmacyList
					items={pharmacies}
					onItemSelect={handlePickPharmacy}
				/>
			</div>
			{isLoading && (
				<div className={styles.loadingWrapper}>
					<Loading />
				</div>
			)}
			{selectedPharmacy && prescriptionId && (
				<DrMaxReserveMedicamentsModal
					isOpen={!!selectedPharmacy}
					onClose={() => setSelectedPharmacy(undefined)}
					prescriptionId={prescriptionId}
					pharmacy={selectedPharmacy}
				/>
			)}
		</>
	);
};

export default DrMaxWrapper;
